import getEnv from '@/env';
import { v4 as uuidv4 } from 'uuid';
import { getCookie, setCookie } from '../cookieUtils';

export enum SplitFeatureFlag {
  SMB_SIGNUP_COMPANY_NAME_AB_TEST = 'smb-signup-company-name-ab-test',
  LL_SIGNUP_SWAPPING_EMAIL_AND_STATE_AB_TEST = 'll-signup-swapping-email-and-state-ab-test',
  MONARCHS_252_ENABLE_V2_SIDE_MENU_DESIGN = 'monarchs-252-enable-v2-side-menu-design',
  MONARCH_271_ENABLE_ONE_PAGE_REGISTRATION = 'monarch-271-enable-one-page-registration',
  OTTERS_2375_ENABLE_DEALS_DASHBOARD_LEASE_DATES_FILTERS = 'otters-2375_enable_deals_dashboard_lease_dates_filters',
  OTTERS_3792_ENABLE_LEASESTARTDATE_FILTER_INPROGRESS = 'otters-3792_enable_leasestartdate_filter_inprogress',
  MONARCH_303_NEW_ENROLLMENT_CONFIRMATION_PAGE_AB_TEST = 'monarch-303-new-enrollment-confirmation-page-ab-test',
}

export const COOKIE_KEY = 'split_anonymous_id';

export const getSplitAnonymousId = (): string => {
  let id = getCookie(COOKIE_KEY);
  if (!id) {
    id = uuidv4();
    setCookie(COOKIE_KEY, id, 365);
  }
  return id;
};

export const splitConfig = {
  core: {
    authorizationKey: getEnv().split_io_api_key || '',
    key: getSplitAnonymousId(),
  },
};
